import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { authReducer, customizationReducer, headerReducer, modalReducer, sidebarReducer } from './slice/index'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import columnSettingsReducer from './slices/columnSettingsSlice'

export default function configureAppStore(preloadedState) {

  const myreducers = combineReducers({
    auth: authReducer,
    sidebar: sidebarReducer,
    customization: customizationReducer,
    header: headerReducer,
    modal: modalReducer,
    columnSettings: columnSettingsReducer
  })

  const persistConfig = {
    key: "root",
    storage
  };

  const persistedReducer = persistReducer(persistConfig, myreducers)

  const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
  })

  const persistor = persistStore(store)


  // if (process.env.NODE_ENV !== 'production' && module.hot) {
  //   module.hot.accept('./reducers', () => store.replaceReducer(rootReducer))
  // }


  return {store, persistor}
}
